var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "600px", persistent: "" },
      model: {
        value: _vm.show,
        callback: function($$v) {
          _vm.show = $$v
        },
        expression: "show"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "primary white--text" },
            [
              _c("v-icon", { attrs: { left: "", color: "white" } }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.modoEdicao ? "mdi-pencil" : "mdi-plus-circle") +
                    " "
                )
              ]),
              _vm._v(
                " " +
                  _vm._s(
                    _vm.modoEdicao
                      ? "Editar Espécie de Título"
                      : "Nova Espécie de Título"
                  ) +
                  " "
              ),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { icon: "", dark: "", disabled: _vm.loading },
                  on: { click: _vm.fecharModal }
                },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-text",
            { staticClass: "pa-6" },
            [
              _c("Loading", {
                attrs: { active: _vm.loading, "is-full-page": false }
              }),
              _c(
                "v-form",
                {
                  ref: "form",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.formValido,
                    callback: function($$v) {
                      _vm.formValido = $$v
                    },
                    expression: "formValido"
                  }
                },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "4" } },
                        [
                          _c("v-text-field", {
                            class: _vm.modoEdicao ? "readonly-field" : "",
                            attrs: {
                              label: "Código da Espécie *",
                              outlined: "",
                              dense: "",
                              disabled: _vm.modoEdicao || _vm.loading,
                              rules: _vm.modoEdicao ? [] : _vm.regrasCodigo,
                              maxlength: "3",
                              counter: "3",
                              hint: "Máx. 3 caracteres",
                              "persistent-hint": ""
                            },
                            model: {
                              value: _vm.form.cd_especie_titulo,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "cd_especie_titulo", $$v)
                              },
                              expression: "form.cd_especie_titulo"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "8" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Nome da Espécie *",
                              outlined: "",
                              dense: "",
                              disabled: _vm.loading,
                              rules: _vm.regrasNome,
                              maxlength: "60",
                              counter: "60",
                              hint: "Máx. 60 caracteres",
                              "persistent-hint": ""
                            },
                            model: {
                              value: _vm.form.nm_especie_titulo,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "nm_especie_titulo", $$v)
                              },
                              expression: "form.nm_especie_titulo"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Descrição Complementar",
                              outlined: "",
                              dense: "",
                              disabled: _vm.loading,
                              rules: _vm.regrasDescricao,
                              maxlength: "200",
                              counter: "200",
                              hint: "Máx. 200 caracteres (opcional)",
                              "persistent-hint": ""
                            },
                            model: {
                              value: _vm.form.ds_complementar_especie_titulo,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "ds_complementar_especie_titulo",
                                  $$v
                                )
                              },
                              expression: "form.ds_complementar_especie_titulo"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6" } },
                        [
                          _c("v-select", {
                            attrs: {
                              items: _vm.opcoesRequerAnexo,
                              "item-text": "label",
                              "item-value": "value",
                              label: "Requer Anexo",
                              outlined: "",
                              dense: "",
                              disabled: _vm.loading
                            },
                            model: {
                              value: _vm.form.requer_anexo,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "requer_anexo", $$v)
                              },
                              expression: "form.requer_anexo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-card-actions",
            { staticClass: "pa-4" },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: {
                    outlined: "",
                    color: "secondary",
                    disabled: _vm.loading
                  },
                  on: { click: _vm.fecharModal }
                },
                [_vm._v(" Cancelar ")]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "ml-2",
                  attrs: {
                    color: "primary",
                    loading: _vm.loading,
                    disabled: _vm.loading
                  },
                  on: { click: _vm.salvar }
                },
                [
                  _c("v-icon", { attrs: { left: "" } }, [
                    _vm._v("mdi-content-save")
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.modoEdicao ? "Salvar Alterações" : "Cadastrar"
                      ) +
                      " "
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }